import api from '@/api'
import router from '@/router'
import jwtDecode from 'jwt-decode'

export const auth = {
  state: {
    loggedUser: {
      username: null,
      role: null,
      isSuperAdmin: null
    }
  },
  getters: {
    loggedUser: state => state.loggedUser
  },
  actions: {
    checkAuth({ commit }) {
      if (!localStorage.getItem('token')) {
        commit('LOGOUT')
      } else {
        commit('SET_USER', localStorage.getItem('token'))
      }
    },
    authUser({ commit }, data) {
      return new Promise((resolve, reject) => {
        api.authUser(data,
          response => {
            commit('SET_USER', response.data)
            router.push('/')
            resolve(response)
          },
          error => {
            reject(error)
          })
      })
    },
    logout({ commit }) {
      commit('LOGOUT')
      router.push('/login')
    }
  },
  mutations: {
    SET_USER(state, token) {
      const permissions = jwtDecode(token).com_astech_perms.find(o => o.per === 'role')
      state.loggedUser.username = jwtDecode(token).prn
      // TODO: set correct role value
      state.loggedUser.role = 'user' // jwtDecode(token).role
      // If any changes happen at portal admin --> role permissions we have to find the correct flag for it.
      // should change 2047 to new flag id.
      if (permissions.flg === 2047) {
        state.loggedUser.isSuperAdmin = true
      } else {
        state.loggedUser.isSuperAdmin = false
      }
      localStorage.setItem('token', token)
    },
    LOGOUT(state) {
      localStorage.removeItem('token')
      state.loggedUser = { username: null, role: null }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js